import { SET_BALANCE } from './../actionTypes';

export const setBalance = balance => ({
    type: SET_BALANCE,
    payload: {
        balance
    }
})